import React from 'react';
import { ChevronLeft, MoreVertical, Plus } from 'lucide-react';
import { Topic } from '../../../../types/topic';
import { useStatusBarInfo } from '../../../../hooks/useStatusBarInfo';
import { useViewport } from '../../../../contexts/ViewportContext';

interface TableHeaderProps {
  topic: Topic;
  onBackClick: () => void;
  showDropdown: boolean;
  setShowDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddRow: () => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
}

export function TableHeader({
  topic,
  onBackClick,
  showDropdown,
  setShowDropdown,
  handleAddRow,
  dropdownRef,
}: TableHeaderProps) {
  const { isNativeApp, statusBarHeight } = useStatusBarInfo();
  const { isMobile } = useViewport();

  return (
    <div
      className="flex items-center h-14 px-4 py-2 w-full sticky top-0 z-20"
      style={{
        paddingTop: isMobile && isNativeApp ? `${statusBarHeight}px` : '0',
        height: isMobile && isNativeApp ? `calc(3.5rem + ${statusBarHeight}px)` : '3.5rem'
      }}
    >
      <div className="flex-none">
        <button onClick={onBackClick} className="p-2 -ml-2 text-gray-600 hover:text-gray-900">
          <ChevronLeft size={24} />
        </button>
      </div>

      <div className="absolute left-1/2 -translate-x-1/2">
        <span className="text-base font-semibold text-gray-900 whitespace-nowrap">
          {topic.name}
        </span>
      </div>

      <div className="flex-1"></div>

      {/* Dropdown menu button */}
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="p-2 text-gray-600 hover:text-gray-900"
        >
          <MoreVertical size={20} />
        </button>

        {/* Dropdown menu */}
        {showDropdown && (
          <div className="absolute right-0 top-full mt-1 bg-white shadow-lg rounded-md border border-gray-200 w-48 z-50">
            <div className="py-1">
              <button
                className="flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 items-center"
                onClick={() => {
                  handleAddRow();
                  setShowDropdown(false);
                }}
              >
                <Plus size={14} className="mr-2" />
                Add row
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
